// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventory-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.7);
  font-family: 'TT Commons', sans-serif;
  z-index: 500;
}
.inventory-container {
  width: 70vw;
  height: 75vh;
  background: rgba(20, 20, 20, 0.95);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  overflow: hidden;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.8);
  position: relative;
}
.inv-debug {
  position: absolute;
  top: 1vh;
  right: 1vh;
  z-index: 9999;
  padding: 0.8vh 1.1vh;
  border-radius: 0.8vh;
  background: rgba(0, 0, 0, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 1.4vh;
  pointer-events: none;
}
.inventory-left {
  width: 20%;
  background: rgba(0, 0, 0, 0.2);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1.5vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.inventory-left .character-header {
  color: #fff;
  font-size: 1.8vw;
  margin-bottom: 1vh;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.1vw;
  flex-shrink: 0;
}
.inventory-left .skins-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  overflow: hidden;
  flex: 1;
  justify-content: space-evenly;
  padding: 0;
  gap: 0;
}
.inventory-left .skin-slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s;
  position: relative;
  justify-content: center;
}
.inventory-left .skin-slot:hover {
  transform: scale(1.05);
}
.inventory-left .skin-slot:hover .skin-circle {
  border-color: rgba(255, 255, 255, 0.5);
}
.inventory-left .skin-slot.selected .skin-circle {
  border-color: #ffcc00;
  box-shadow: 0 0 15px rgba(255, 204, 0, 0.3);
}
.inventory-left .skin-slot.selected .skin-label {
  color: #ffcc00;
}
.inventory-left .skin-slot.equipped-skin .skin-circle {
  border-color: #4caf50;
  box-shadow: 0 0 10px rgba(76, 175, 80, 0.3);
}
.inventory-left .skin-slot.equipped-skin .skin-label {
  color: #4caf50;
}
.inventory-left .skin-slot .skin-circle {
  width: 9vh;
  height: 9vh;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-bottom: 0.5vh;
  transition: border-color 0.2s;
}
.inventory-left .skin-slot .skin-circle .skin-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.inventory-left .skin-slot .skin-circle .skin-placeholder {
  font-size: 4vh;
  opacity: 0.3;
}
.inventory-left .skin-slot .skin-label {
  font-size: 1.2vh;
  color: #888;
  text-align: center;
}
.inventory-close {
  position: absolute;
  top: 0.9vw;
  right: 0.9vw;
  left: auto;
  z-index: 999;
  width: clamp(28px, 2.2vw, 40px);
  height: clamp(28px, 2.2vw, 40px);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid rgba(30, 26, 27, 0.75);
  background: rgba(129, 115, 117, 0.1);
  color: #f0f0f0e8;
  font-size: clamp(18px, 1.6vw, 26px);
  line-height: 1;
  cursor: pointer;
  transition: transform 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}
.inventory-close:hover {
  background: rgba(255, 40, 80, 0.16);
  transform: scale(1.06);
  box-shadow: 0 0 14px rgba(255, 40, 80, 0.7), 0 0 28px rgba(255, 40, 80, 0.35);
}
.inventory-close:active {
  transform: scale(0.98);
}
.inventory-content {
  display: flex;
  flex: 1;
  min-height: 0;
  gap: 1.5vw;
  overflow: visible;
}
.inventory-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 1.5vw;
}
.inventory-right .inventory-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5vw;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 0.8vw;
  padding-right: clamp(42px, 3.2vw, 60px);
}
.inventory-right .inventory-header h2 {
  color: #fff;
  font-size: 2vw;
  margin: 0;
}
.inventory-right .inventory-header .inventory-title {
  display: flex;
  align-items: center;
  gap: 1vw;
}
.inventory-right .inventory-header .slots-info {
  color: #666;
  font-size: 1.1vw;
}
.inventory-right .inventory-header .header-right {
  display: flex;
  align-items: center;
  gap: 0.8vw;
}
.slots-grid {
  flex: 2;
  display: grid;
  min-width: 0;
  min-height: 0;
  height: 100%;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-auto-rows: minmax(0, 1fr);
  gap: 0.6vw;
  padding-right: 0.5vw;
  padding-bottom: 0.6vw;
  align-content: start;
}
.slots-grid::-webkit-scrollbar {
  width: 4px;
}
.slots-grid::-webkit-scrollbar-track {
  background: transparent;
}
.slots-grid::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 2px;
}
.inv-slot {
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid transparent;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: all 0.2s;
  height: auto;
  aspect-ratio: 1 / 1;
}
.inv-slot:hover {
  background: rgba(255, 255, 255, 0.08);
}
.inv-slot.selected {
  border-color: #ffcc00;
  background: rgba(255, 204, 0, 0.05);
}
.inv-slot .item-img {
  max-width: 70%;
  max-height: 70%;
  object-fit: contain;
  margin-bottom: 0.2vw;
}
.inv-slot .item-icon-placeholder {
  font-size: 2vw;
  color: #555;
}
.inv-slot .item-name {
  min-width: 0;
  font-size: 0.75vw;
  color: #ccc;
  text-align: center;
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.inv-slot .item-count {
  position: absolute;
  bottom: 0.3vw;
  right: 0.4vw;
  font-size: 0.8vw;
  color: #aaa;
  background: rgba(0, 0, 0, 0.5);
  padding: 0 0.3vw;
  border-radius: 4px;
}
.item-info-panel {
  width: 17vw;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 1.2vw;
  border: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
.item-info-panel .info-panel-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding-right: 0.2vw;
}
.item-info-panel .info-panel-content::-webkit-scrollbar {
  width: 4px;
}
.item-info-panel .info-panel-content::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 2px;
}
.item-info-panel .info-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1vw;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 1vw;
  flex-shrink: 0;
}
.item-info-panel .info-title {
  color: #fff;
  font-size: 1.2vw;
  text-align: center;
  margin-bottom: 1vw;
  font-weight: bold;
}
.item-info-panel .info-big-icon {
  width: 7vw;
  height: 7vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.05) 0%, rgba(0, 0, 0, 0) 70%);
  border-radius: 50%;
}
.item-info-panel .info-big-icon img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.5));
}
.item-info-panel .info-big-icon .item-icon-placeholder {
  font-size: 3vw;
  opacity: 0.5;
}
.item-info-panel .info-scrollable-content {
  flex: 0 1 auto;
  min-height: 0;
  overflow-y: hidden;
  margin-bottom: 0.8vw;
}
.item-info-panel .info-scrollable-content::-webkit-scrollbar {
  width: 4px;
}
.item-info-panel .info-scrollable-content::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 2px;
}
.item-info-panel .info-desc {
  color: #aaa;
  font-size: 0.9vw;
  line-height: 1.4;
  background: rgba(0, 0, 0, 0);
  padding: 0.8vw;
  border-radius: 6px;
}
.item-info-panel .info-desc .status-green {
  color: #4caf50;
  font-weight: bold;
  margin-top: 5px;
}
.item-info-panel .desc-label {
  font-size: 0.9vw;
  color: #aaa;
  margin-bottom: 0.5vw;
  text-align: center;
}
.item-info-panel .equipped-grid-small {
  display: grid;
  min-width: 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5vw;
  width: 100%;
}
.item-info-panel .equip-box {
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  aspect-ratio: 1;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;
  position: relative;
}
.item-info-panel .equip-box:hover {
  background: rgba(255, 255, 255, 0.15);
}
.item-info-panel .equip-box.selected {
  border-color: #ffcc00;
  background: rgba(255, 204, 0, 0.1);
}
.item-info-panel .equip-box img {
  width: 80%;
  height: 80%;
  object-fit: contain;
}
.item-info-panel .equip-box .no-icon {
  font-size: 0.85vw;
  color: #777;
}
.item-info-panel .equip-box .empty-plus {
  font-size: 1.2vw;
  color: rgba(255, 255, 255, 0.1);
}
.item-info-panel .info-actions {
  display: flex;
  flex-direction: column;
  gap: 0.6vw;
  flex-shrink: 0;
  margin-top: 0;
}
.item-info-panel .info-actions .status-badge {
  text-align: center;
  padding: 0.8vw;
  background: rgba(76, 175, 80, 0.2);
  border: 1px solid #4caf50;
  color: #4caf50;
  border-radius: 6px;
  font-weight: bold;
  font-size: 1vw;
}
.item-info-panel .info-actions button {
  padding: 0.6vw;
  padding-bottom: 0.3vw;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-family: inherit;
  font-size: 1vw;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.05vw;
  transition: filter 0.2s, transform 0.1s;
}
.item-info-panel .info-actions button:hover {
  filter: brightness(1.2);
}
.item-info-panel .info-actions button:active {
  transform: scale(0.98);
}
.item-info-panel .info-actions .btn-use {
  background: linear-gradient(135deg, #00cc66 0%, #00994d 100%);
  color: #fff;
  box-shadow: 0 4px 10px rgba(0, 204, 102, 0.2);
}
.item-info-panel .info-actions .btn-drop {
  background: linear-gradient(135deg, #cc3333 0%, #992626 100%);
  color: #fff;
  box-shadow: 0 4px 10px rgba(204, 51, 51, 0.2);
}
.item-info-panel .info-actions .btn-store {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: #fff;
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.2);
}
.item-info-panel .info-actions .btn-sell {
  background: linear-gradient(135deg, #ffcc00 0%, #f59e0b 100%);
  color: #1a1a1a;
  box-shadow: 0 4px 10px rgba(255, 204, 0, 0.22);
}
.item-info-panel .info-actions .btn-edit {
  background: linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%);
  color: #fff;
  box-shadow: 0 4px 10px rgba(142, 68, 173, 0.2);
}
.item-info-panel .info-actions .btn-back {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0.06) 100%);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.22);
}
.inventory-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1vw;
  margin-top: 0.8vw;
  user-select: none;
}
.pager-btn {
  width: 3.2vw;
  height: 2.4vw;
  border-radius: 0.7vw;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.3vw;
  cursor: pointer;
  transition: filter 0.2s, transform 0.1s, background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pager-btn:hover {
  filter: brightness(1.15);
  background: rgba(255, 255, 255, 0.1);
}
.pager-btn:active {
  transform: scale(0.98);
}
.pager-btn.disabled {
  opacity: 0.35;
  pointer-events: none;
}
.pager-info {
  color: rgba(255, 255, 255, 0.85);
  font-size: 1.1vw;
  padding: 0.2vw 0.9vw;
  border-radius: 0.8vw;
  background: rgba(0, 0, 0, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.08);
}
/* pager inside header next to title */
.inventory-pager.in-header {
  margin-top: 0;
  gap: 0.6vw;
}
.inventory-pager.in-header .pager-btn {
  width: 2.6vw;
  height: 1.9vw;
  font-size: 1.1vw;
  border-radius: 0.6vw;
}
.inventory-pager.in-header .pager-info {
  font-size: 1vw;
  padding: 0.1vw 0.6vw;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.08);
}
`, "",{"version":3,"sources":["webpack://./src/components/inventory/assets/style.less"],"names":[],"mappings":"AAMA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,qCAAA;EACA,YAAA;AALJ;AAQA;EACI,WAAA;EACA,YAAA;EACA,kCAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;EACA,uCAAA;EACA,kBAAA;AANJ;AASA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,oBAAA;EACA,oBAAA;EACA,+BAAA;EACA,2CAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;AAPF;AAWA;EACI,UAAA;EACA,8BAAA;EACA,gDAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AATJ;AAEA;EAUQ,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AATR;AAPA;EAoBQ,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,OAAA;EACA,6BAAA;EACA,UAAA;EACA,MAAA;AAVR;AAlBA;EAgCQ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,uBAAA;AAXR;AAaQ;EACI,sBAAA;AAXZ;AAUQ;EAEmB,sCAAA;AAT3B;AAYQ;EAEQ,qBAAA;EACA,2CAAA;AAXhB;AAQQ;EAKkB,cAAA;AAV1B;AAaQ;EAES,qBAAA;EACA,2CAAA;AAZjB;AASQ;EAKmB,cAAA;AAX3B;AA/CA;EA8DY,UAAA;EACA,WAAA;EAEA,kBAAA;EACA,qCAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,6BAAA;AAbZ;AA5DA;EA4EgB,WAAA;EACA,YAAA;EACA,iBAAA;AAbhB;AAjEA;EAiFgB,cAAA;EACA,YAAA;AAbhB;AArEA;EAuFY,gBAAA;EACA,WAAA;EACA,kBAAA;AAfZ;AAoBC;EACG,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EAEA,+BAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,wCAAA;EACA,oCAAA;EAEA,gBAAA;EACA,mCAAA;EACA,cAAA;EAEA,eAAA;EAIA,8EAAA;AAzBJ;AA4BE;EACE,mCAAA;EACA,sBAAA;EACA,6EAAA;AA1BJ;AA+BE;EACE,sBAAA;AA7BJ;AAiCI;EACI,aAAA;EACA,OAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;AA/BR;AAmCA;EACI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AAjCJ;AA6BA;EAOQ,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;EACA,qBAAA;EACA,uCAAA;AAjCR;AAoBA;EAgBY,WAAA;EACA,cAAA;EACA,SAAA;AAjCZ;AAeA;EAsBY,aAAA;EACA,mBAAA;EACA,QAAA;AAlCZ;AAUA;EA2BY,WAAA;EACA,gBAAA;AAlCZ;AAMA;EAgCM,aAAA;EACA,mBAAA;EACA,UAAA;AAnCN;AAyCA;EACI,OAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EAEA,gDAAA;EACA,8BAAA;EACA,UAAA;EAKA,oBAAA;EACA,qBAAA;EACA,oBAAA;AA5CJ;AA8CI;EAAuB,UAAA;AA3C3B;AA4CI;EAA6B,uBAAA;AAzCjC;AA0CI;EAA6B,gBAAA;EAAkB,kBAAA;AAtCnD;AAyCA;EACI,WAAA;EACA,sBAAA;EACA,YAAA;EACA,qCAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;AAvCJ;AAyCI;EAAU,qCAAA;AAtCd;AAwCI;EACI,qBAAA;EACA,mCAAA;AAtCR;AAiBA;EAyBQ,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;AAvCR;AAWA;EA8B6B,cAAA;EAAgB,WAAA;AArC7C;AAOA;EAgCQ,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AApCR;AAHA;EA0CQ,kBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;AApCR;AAyCA;EACI,WAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAvCJ;AA4BA;EAcQ,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,gBAAA;EACA,oBAAA;AAxCR;AA0CQ;EAAuB,UAAA;AAvC/B;AAwCQ;EAA6B,gBAAA;EAAkB,kBAAA;AApCvD;AAcA;EA0BQ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iDAAA;EACA,mBAAA;EACA,cAAA;AArCR;AAKA;EAoCQ,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAtCR;AAFA;EA4CQ,UAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uFAAA;EACA,kBAAA;AAvCR;AAXA;EAqDY,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gDAAA;AAvCZ;AAjBA;EA0DiC,cAAA;EAAgB,YAAA;AArCjD;AArBA;EA+DQ,cAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;AAvCR;AAyCQ;EAAuB,UAAA;AAtC/B;AAuCQ;EAA6B,gBAAA;EAAkB,kBAAA;AAnCvD;AAlCA;EAyEQ,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AApCR;AA1CA;EAgFwB,cAAA;EAAgB,iBAAA;EAAmB,eAAA;AAjC3D;AA/CA;EAoFQ,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;AAlCR;AArDA;EA2FQ,aAAA;EACA,YAAA;EACA,gDAAA;EACA,UAAA;EACA,WAAA;AAnCR;AA5DA;EAmGQ,WAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,qCAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AApCR;AAsCQ;EAAU,qCAAA;AAnClB;AAqCQ;EACI,qBAAA;EACA,kCAAA;AAnCZ;AAlFA;EAyHY,UAAA;EACA,WAAA;EACA,mBAAA;AApCZ;AAvFA;EA6HmB,iBAAA;EAAmB,WAAA;AAlCtC;AA3FA;EA8HsB,gBAAA;EAAkB,+BAAA;AA/BxC;AA/FA;EAkIQ,aAAA;EACA,sBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;AAhCR;AAtGA;EAyIY,kBAAA;EACA,cAAA;EACA,kCAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAhCZ;AAhHA;EAoJY,cAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uCAAA;AAjCZ;AAmCY;EAAU,uBAAA;AAhCtB;AAiCY;EAAW,sBAAA;AA9BvB;AAnIA;EAqKY,6DAAA;EACA,WAAA;EACA,6CAAA;AA/BZ;AAxIA;EA2KY,6DAAA;EACA,WAAA;EACA,6CAAA;AAhCZ;AA7IA;EAgLQ,6DAAA;EACA,WAAA;EACA,8CAAA;AAhCR;AAlJA;EAqLY,6DAAA;EACA,cAAA;EACA,8CAAA;AAhCZ;AAvJA;EA0LY,6DAAA;EACA,WAAA;EACA,8CAAA;AAhCZ;AA5JA;EA+LY,iGAAA;EACA,WAAA;EACA,2CAAA;EACA,0CAAA;AAhCZ;AAuCA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;AArCJ;AAwCA;EACI,YAAA;EACA,aAAA;EACA,oBAAA;EACA,2CAAA;EACA,qCAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,wDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtCJ;AAwCI;EAAU,wBAAA;EAA0B,oCAAA;AApCxC;AAqCI;EAAW,sBAAA;AAlCf;AAmCI;EAAa,aAAA;EAAe,oBAAA;AA/BhC;AAkCA;EACI,gCAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,+BAAA;EACA,2CAAA;AAhCJ;AACA,sCAAsC;AAoCtC;EACI,aAAA;EACA,UAAA;AAlCJ;AAqCA;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;AAnCJ;AAsCA;EACI,cAAA;EACA,oBAAA;EACA,uBAAA;EACA,2CAAA;AApCJ","sourcesContent":["// Основные переменные\n@bg-dark: rgba(20, 20, 20, 0.95);\n@bg-slot: rgba(255, 255, 255, 0.05);\n@border-color: rgba(255, 255, 255, 0.1);\n@accent-color: #ffcc00;\n\n.inventory-wrapper {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: rgba(0, 0, 0, 0.7);\n    font-family: 'TT Commons', sans-serif;\n    z-index: 500;\n}\n\n.inventory-container {\n    width: 70vw;\n    height: 75vh;\n    background: @bg-dark;\n    border-radius: 12px;\n    border: 1px solid @border-color;\n    display: flex;\n    overflow: hidden;\n    box-shadow: 0 0 30px rgba(0,0,0,0.8);\n    position: relative;\n}\n//----DEBUG INFO----\n.inv-debug{\n  position: absolute;\n  top: 1vh;\n  right: 1vh;\n  z-index: 9999;\n  padding: .8vh 1.1vh;\n  border-radius: .8vh;\n  background: rgba(0,0,0,.55);\n  border: 1px solid rgba(255,255,255,.15);\n  color: #fff;\n  font-size: 1.4vh;\n  pointer-events: none;\n}\n//-----END DEBUG----\n// --- ЛЕВАЯ КОЛОНКА (Скины) ---\n.inventory-left {\n    width: 20%;\n    background: rgba(0, 0, 0, 0.2);\n    border-right: 1px solid @border-color;\n    padding: 1.5vw;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    .character-header {\n        color: #fff;\n        font-size: 1.8vw;\n        margin-bottom: 1vh; \n        font-weight: bold;\n        text-transform: uppercase;\n        letter-spacing: 0.1vw;\n        flex-shrink: 0;\n    }\n\n    .skins-container {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        align-items: center;\n        overflow: hidden; \n        flex: 1;\n        justify-content: space-evenly;\n        padding: 0;\n        gap: 0;\n    }\n\n    .skin-slot {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        cursor: pointer;\n        transition: transform 0.2s;\n        position: relative;\n        justify-content: center;\n\n        &:hover {\n            transform: scale(1.05);\n            .skin-circle { border-color: rgba(255,255,255,0.5); }\n        }\n\n        &.selected {\n            .skin-circle {\n                border-color: @accent-color;\n                box-shadow: 0 0 15px fade(@accent-color, 30%);\n            }\n            .skin-label { color: @accent-color; }\n        }\n\n        &.equipped-skin {\n             .skin-circle {\n                 border-color: #4caf50;\n                 box-shadow: 0 0 10px rgba(76, 175, 80, 0.3);\n             }\n             .skin-label { color: #4caf50; }\n        }\n\n        .skin-circle {\n            width: 9vh; \n            height: 9vh;\n            \n            border-radius: 50%;\n            background: @bg-slot;\n            border: 2px solid @border-color;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            overflow: hidden;\n            margin-bottom: 0.5vh;\n            transition: border-color 0.2s;\n\n            .skin-img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n            }\n            .skin-placeholder {\n                font-size: 4vh; \n                opacity: 0.3;\n            }\n        }\n\n        .skin-label {\n            font-size: 1.2vh; \n            color: #888;\n            text-align: center;\n        }\n    }\n}\n\n .inventory-close {\n    position: absolute;\n    top: 0.9vw;\n    right: 0.9vw;\n    left: auto;          // на всякий случай\n    z-index: 999;        // чтобы всегда была сверху\n\n    width: clamp(28px, 2.2vw, 40px);\n    height: clamp(28px, 2.2vw, 40px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    border-radius: 10px;\n    border: 1px solid rgba(30, 26, 27, 0.75);\n    background: rgba(129, 115, 117, 0.1);\n\n    color: #f0f0f0e8;\n    font-size: clamp(18px, 1.6vw, 26px);\n    line-height: 1;\n\n    cursor: pointer;\n\n\n\n    transition: transform 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n  }\n\n  .inventory-close:hover {\n    background: rgba(255, 40, 80, 0.16);\n    transform: scale(1.06);\n    box-shadow:\n      0 0 14px rgba(255, 40, 80, 0.70),\n      0 0 28px rgba(255, 40, 80, 0.35);\n  }\n\n  .inventory-close:active {\n    transform: scale(0.98);\n  }\n\n\n    .inventory-content {\n        display: flex;\n        flex: 1;\n        min-height: 0;\n        gap: 1.5vw;\n        overflow: visible;\n    }\n\n// --- ПРАВАЯ КОЛОНКА (Предметы) ---\n.inventory-right {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 1.5vw;\n\n    .inventory-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 1.5vw;\n        border-bottom: 1px solid @border-color;\n        padding-bottom: 0.8vw;\n        padding-right: clamp(42px, 3.2vw, 60px);\n\n        h2 {\n            color: #fff;\n            font-size: 2vw;\n            margin: 0;\n        }\n        \n        .inventory-title {\n            display: flex;\n            align-items: center;\n            gap: 1vw;\n        }\n        .slots-info {\n            color: #666;\n            font-size: 1.1vw;\n        }\n\n     .header-right {\n      display: flex;\n      align-items: center;\n      gap: 0.8vw;\n    }\n  }\n}\n\n// СЕТКА ПРЕДМЕТОВ\n.slots-grid {\n    flex: 2;\n    display: grid;\n    min-width: 0;\n    min-height: 0;\n    height: 100%;\n    \n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    grid-auto-rows: minmax(0, 1fr); \n    gap: 0.6vw;\n    \n    //скролл\n    //overflow-y: auto; \n    \n    padding-right: 0.5vw;\n    padding-bottom: 0.6vw;\n    align-content: start;\n\n    &::-webkit-scrollbar { width: 4px; }\n    &::-webkit-scrollbar-track { background: transparent; }\n    &::-webkit-scrollbar-thumb { background: #444; border-radius: 2px; }\n}\n\n.inv-slot {\n    width: 100%;\n    box-sizing: border-box;\n    min-width: 0;\n    background: @bg-slot;\n    border: 1px solid transparent;\n    border-radius: 6px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    position: relative;\n    transition: all 0.2s;\n    height: auto;\n    aspect-ratio: 1 / 1;\n\n    &:hover { background: rgba(255, 255, 255, 0.08); }\n\n    &.selected {\n        border-color: @accent-color;\n        background: fade(@accent-color, 5%);\n    }\n\n    .item-img {\n        max-width: 70%;\n        max-height: 70%;\n        object-fit: contain;\n        margin-bottom: 0.2vw;\n    }\n    .item-icon-placeholder { font-size: 2vw; color: #555; }\n    .item-name {\n        min-width: 0;\n        font-size: 0.75vw;\n        color: #ccc;\n        text-align: center;\n        width: 90%;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    .item-count {\n        position: absolute;\n        bottom: 0.3vw;\n        right: 0.4vw;\n        font-size: 0.8vw;\n        color: #aaa;\n        background: rgba(0,0,0,0.5);\n        padding: 0 0.3vw;\n        border-radius: 4px;\n    }\n}\n\n// --- ИНФО ПАНЕЛЬ ---\n.item-info-panel {\n    width: 17vw;\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 8px;\n    padding: 1.2vw;\n    border: 1px solid @border-color;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 0;\n    overflow: hidden;\n\n    .info-panel-content {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        \n        overflow-y: auto; \n        padding-right: 0.2vw; \n        \n        &::-webkit-scrollbar { width: 4px; }\n        &::-webkit-scrollbar-thumb { background: #444; border-radius: 2px; }\n    }\n\n    .info-header {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        margin-bottom: 1vw;\n        border-bottom: 1px solid @border-color;\n        padding-bottom: 1vw;\n        flex-shrink: 0;\n    }\n\n    .info-title {\n        color: #fff;\n        font-size: 1.2vw;\n        text-align: center;\n        margin-bottom: 1vw;\n        font-weight: bold;\n    }\n\n    .info-big-icon {\n        width: 7vw;\n        height: 7vw;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: radial-gradient(circle, rgba(255,255,255,0.05) 0%, rgba(0,0,0,0) 70%);\n        border-radius: 50%;\n\n        img {\n            max-width: 100%;\n            max-height: 100%;\n            object-fit: contain;\n            filter: drop-shadow(0 0 10px rgba(0,0,0,0.5));\n        }\n        .item-icon-placeholder { font-size: 3vw; opacity: 0.5; }\n    }\n\n    // FIX: контент не растягивается в пустоту, скролл только если реально не влезает\n    .info-scrollable-content {\n        flex: 0 1 auto;\n        min-height: 0;\n        overflow-y: hidden; // paging: no scroll\n        margin-bottom: 0.8vw;\n\n        &::-webkit-scrollbar { width: 4px; }\n        &::-webkit-scrollbar-thumb { background: #444; border-radius: 2px; }\n    }\n\n    .info-desc {\n        color: #aaa;\n        font-size: 0.9vw;\n        line-height: 1.4;\n        background: rgba(0, 0, 0, 0);\n        padding: 0.8vw;\n        border-radius: 6px;\n\n        .status-green { color: #4caf50; font-weight: bold; margin-top: 5px; }\n    }\n\n    .desc-label {\n        font-size: 0.9vw;\n        color: #aaa;\n        margin-bottom: 0.5vw;\n        text-align: center;\n    }\n\n    .equipped-grid-small {\n        display: grid;\n        min-width: 0;\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n        gap: 0.5vw;\n        width: 100%;\n    }\n\n    .equip-box {\n        width: 100%;\n        box-sizing: border-box;\n        min-width: 0;\n        aspect-ratio: 1;\n        background: rgba(255, 255, 255, 0.05);\n        border: 1px solid rgba(255, 255, 255, 0.1);\n        border-radius: 6px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        transition: 0.2s;\n        position: relative;\n\n        &:hover { background: rgba(255, 255, 255, 0.15); }\n\n        &.selected {\n            border-color: @accent-color;\n            background: rgba(255, 204, 0, 0.1);\n        }\n\n        img {\n            width: 80%;\n            height: 80%;\n            object-fit: contain;\n        }\n        .no-icon { font-size: 0.85vw; color: #777; }\n        .empty-plus { font-size: 1.2vw; color: rgba(255, 255, 255, 0.1); }\n    }\n\n    .info-actions {\n        display: flex;\n        flex-direction: column;\n        gap: 0.6vw;\n        flex-shrink: 0;\n        margin-top: 0;\n\n        .status-badge {\n            text-align: center;\n            padding: 0.8vw;\n            background: rgba(76, 175, 80, 0.2);\n            border: 1px solid #4caf50;\n            color: #4caf50;\n            border-radius: 6px;\n            font-weight: bold;\n            font-size: 1vw;\n        }\n\n        button {\n            padding: 0.6vw;\n            padding-bottom: 0.3vw;\n            border: none;\n            border-radius: 6px;\n            cursor: pointer;\n            font-family: inherit;\n            font-size: 1vw;\n            font-weight: bold;\n            text-transform: uppercase;\n            letter-spacing: 0.05vw;\n            transition: filter 0.2s, transform 0.1s;\n\n            &:hover { filter: brightness(1.2); }\n            &:active { transform: scale(0.98); }\n        }\n\n        .btn-use {\n            background: linear-gradient(135deg, #00cc66 0%, #00994d 100%);\n            color: #fff;\n            box-shadow: 0 4px 10px rgba(0, 204, 102, 0.2);\n        }\n\n        .btn-drop {\n            background: linear-gradient(135deg, #cc3333 0%, #992626 100%);\n            color: #fff;\n            box-shadow: 0 4px 10px rgba(204, 51, 51, 0.2);\n        }\n        .btn-store {\n        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n        color: #fff;\n        box-shadow: 0 4px 10px rgba(59, 130, 246, 0.2);\n        }\n        .btn-sell {\n            background: linear-gradient(135deg, #ffcc00 0%, #f59e0b 100%);\n            color: #1a1a1a;\n            box-shadow: 0 4px 10px rgba(255, 204, 0, 0.22);\n        }\n        .btn-edit {\n            background: linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%);\n            color: #fff;\n            box-shadow: 0 4px 10px rgba(142, 68, 173, 0.2);\n        }\n        .btn-back {\n            background: linear-gradient(135deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0.06) 100%);\n            color: #fff;\n            border: 1px solid rgba(255, 255, 255, 0.16);\n            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.22);\n        }\n    }\n}\n// -----------------------------\n// CEF INVENTORY PAGER (pagination)\n// -----------------------------\n.inventory-pager {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1vw;\n    margin-top: 0.8vw;\n    user-select: none;\n}\n\n.pager-btn {\n    width: 3.2vw;\n    height: 2.4vw;\n    border-radius: 0.7vw;\n    border: 1px solid rgba(255,255,255,0.12);\n    background: rgba(255,255,255,0.06);\n    color: rgba(255,255,255,0.9);\n    font-size: 1.3vw;\n    cursor: pointer;\n    transition: filter 0.2s, transform 0.1s, background 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:hover { filter: brightness(1.15); background: rgba(255,255,255,0.10); }\n    &:active { transform: scale(0.98); }\n    &.disabled { opacity: 0.35; pointer-events: none; }\n}\n\n.pager-info {\n    color: rgba(255,255,255,0.85);\n    font-size: 1.1vw;\n    padding: 0.2vw 0.9vw;\n    border-radius: 0.8vw;\n    background: rgba(0,0,0,0.22);\n    border: 1px solid rgba(255,255,255,0.08);\n}\n\n\n/* pager inside header next to title */\n.inventory-pager.in-header {\n    margin-top: 0;\n    gap: 0.6vw;\n}\n\n.inventory-pager.in-header .pager-btn {\n    width: 2.6vw;\n    height: 1.9vw;\n    font-size: 1.1vw;\n    border-radius: 0.6vw;\n}\n\n.inventory-pager.in-header .pager-info {\n    font-size: 1.0vw;\n    padding: 0.1vw 0.6vw;\n    background: transparent;\n    border: 1px solid rgba(255,255,255,0.08);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
